// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1YkJe","file":"styles_file__zjE1x"};